<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <v-card color="#977EBE" elevation="0" height="150px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-crown-outline</v-icon>
                    &nbsp;ITS
                </v-card-title>
            </v-card>
            <v-card-text>
                This page is only accessible to ITS staffs only. 
                Changes made on this page impact student or&#40;and&#41; admin experience on SFS portal.
            </v-card-text>
            <v-card-text>
                <LoginControlManager />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import LoginControlManager from "../../../components/Admin/ITS/Manager.vue"
export default {
    components: {
        LoginControlManager
    }
}
</script>